import React from "react";

const Footer: React.FC = () => {
  const socialLinks = [
    {
      name: "Email",
      href: "mailto:me@alexmari.phd",
      icon: "fas fa-envelope",
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/in/alexmari/",
      icon: "fab fa-linkedin",
    },
    {
      name: "X",
      href: "https://x.com/Mariketing",
      icon: "𝕏",
      isText: true,
    },
    {
      name: "Google Scholar",
      href: "https://scholar.google.com/citations?user=MKAavP4AAAAJ&hl=en",
      icon: "fas fa-graduation-cap",
    },
    {
      name: "ResearchGate",
      href: "https://www.researchgate.net/profile/Alex-Mari",
      icon: "fab fa-researchgate",
    },
  ];

  return (
    <>
      {/* Font Awesome CDN */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossOrigin="anonymous"
      />

      <footer className="footer">
        <div className="container">
          <div className="footer-main">
            {/* Left Section - Profile & Contact */}
            <div className="footer-left">
              <div className="footer-profile">
                <img
                  src="/images/Dr-Alex-Mari-AI-Empathy-Reaeach.jpg"
                  alt="Dr. Alex Mari"
                  className="footer-profile-image"
                  style={{ marginRight: "1rem" }}
                />
                <div className="footer-profile-info">
                  <h3>Dr. Alex Mari</h3>
                  <p>Professor & Researcher</p>
                  <p>Marketing and AI</p>
                  <p>Bahrain, Middle East</p>
                </div>
              </div>
            </div>

            {/* Center Section - Social Links */}
            <div className="footer-center">
              <div className="footer-nav">
                <h4>Personal</h4>
                <ul>
                  <li>
                    <a href="mailto:me@alexmari.phd">Email</a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/alexmari/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://x.com/Mariketing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      X (Twitter)
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-nav">
                <h4>Academic</h4>
                <ul>
                  <li>
                    <a
                      href="https://scholar.google.com/citations?user=MKAavP4AAAAJ&hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Google Scholar
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.researchgate.net/profile/Alex-Mari"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      ResearchGate
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Right Section - CTA */}
            <div className="footer-right">
              <div className="footer-cta">
                <h4>Ready to collaborate?</h4>
                <a
                  href="/files/CV-Prof-Dr-Alex-Mari-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-cv-btn"
                >
                  <i className="fas fa-download"></i>
                  Download CV
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <div className="footer-logo">
                <video
                  className="footer-logo-video"
                  autoPlay
                  muted
                  playsInline
                  preload="auto"
                  ref={(video) => {
                    if (video) {
                      video.play().catch(() => {
                        // Autoplay failed, but that's ok
                      });
                    }
                  }}
                >
                  <source src="/images/logo.mp4" type="video/mp4" />
                </video>
              </div>
              <div className="footer-copyright">
                <p>&copy; 2025 Dr. Alex Mari. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
